import React, { type ReactNode } from 'react';
import { Box } from '@mui/material';

import { combineSx, formStyles } from './ClaimCMS1500Form.styles';

interface CMS1500TemplateProps {
  box1?: ReactNode;
  box1a?: ReactNode;
  box2?: ReactNode;
  box3?: ReactNode;
  box4?: ReactNode;
  box5?: ReactNode;
  box6?: ReactNode;
  box7?: ReactNode;
  box8?: ReactNode;
  box9?: ReactNode;
  box10?: ReactNode;
  box11?: ReactNode;
  box12?: ReactNode;
  box13?: ReactNode;
  box14?: ReactNode;
  box15?: ReactNode;
  box16?: ReactNode;
  box17?: ReactNode;
  box18?: ReactNode;
  box19?: ReactNode;
  box20?: ReactNode;
  box21?: ReactNode;
  box22?: ReactNode;
  box23?: ReactNode;
  box24?: ReactNode;
  box25?: ReactNode;
  box26?: ReactNode;
  box27?: ReactNode;
  box28?: ReactNode;
  box29?: ReactNode;
  box30?: ReactNode;
  box31?: ReactNode;
  box32?: ReactNode;
  box33?: ReactNode;
}

export const CMS1500Template: React.FC<CMS1500TemplateProps> = (props) => {
  return (
    <Box sx={formStyles.formGrid}>
      {/* Row 1: Boxes 1 & 1a */}
      <Box sx={combineSx(formStyles.box, formStyles.box1)} data-cms-box="1">
        {props.box1}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box1a)} data-cms-box="1a">
        {props.box1a}
      </Box>

      {/* Row 2: Boxes 2, 3, 4 */}
      <Box sx={combineSx(formStyles.box, formStyles.box2)} data-cms-box="2">
        {props.box2}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box3)} data-cms-box="3">
        {props.box3}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box4)} data-cms-box="4">
        {props.box4}
      </Box>

      {/* Row 3: Boxes 5, 6/8 (nested), 7 */}
      <Box sx={combineSx(formStyles.box, formStyles.box5)} data-cms-box="5">
        {props.box5}
      </Box>
      
      {/* Box 6 & 8 (nested grid) */}
      <Box sx={combineSx(formStyles.box6and8)}>
        <Box sx={combineSx(formStyles.box, formStyles.box6)} data-cms-box="6">
          {props.box6}
        </Box>
        <Box sx={combineSx(formStyles.box, formStyles.box8)} data-cms-box="8">
          {props.box8}
        </Box>
      </Box>
      
      <Box sx={combineSx(formStyles.box, formStyles.box7)} data-cms-box="7">
        {props.box7}
      </Box>

      {/* Row 4: Boxes 9, 10, 11 */}
      <Box sx={combineSx(formStyles.box, formStyles.box9)} data-cms-box="9">
        {props.box9}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box10)} data-cms-box="10">
        {props.box10}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box11)} data-cms-box="11">
        {props.box11}
      </Box>

      {/* Row 5: Boxes 12 & 13 */}
      <Box sx={combineSx(formStyles.box, formStyles.box12)} data-cms-box="12">
        {props.box12}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box13)} data-cms-box="13">
        {props.box13}
      </Box>

      {/* Row 6: Boxes 14, 15, 16 */}
      <Box sx={combineSx(formStyles.box, formStyles.box14)} data-cms-box="14">
        {props.box14}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box15)} data-cms-box="15">
        {props.box15}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box16)} data-cms-box="16">
        {props.box16}
      </Box>

      {/* Row 7: Boxes 17 & 18 */}
      <Box sx={combineSx(formStyles.box, formStyles.box17)} data-cms-box="17">
        {props.box17}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box18)} data-cms-box="18">
        {props.box18}
      </Box>

      {/* Row 8: Boxes 19 & 20 */}
      <Box sx={combineSx(formStyles.box, formStyles.box19)} data-cms-box="19">
        {props.box19}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box20)} data-cms-box="20">
        {props.box20}
      </Box>

      {/* Row 9: Boxes 21, 22/23 (nested) */}
      <Box sx={combineSx(formStyles.box, formStyles.box21)} data-cms-box="21">
        {props.box21}
      </Box>
      
      {/* Box 22 & 23 (nested grid) */}
      <Box sx={combineSx(formStyles.box22and23)}>
        <Box sx={combineSx(formStyles.box, formStyles.box22)} data-cms-box="22">
          {props.box22}
        </Box>
        <Box sx={combineSx(formStyles.box, formStyles.box23)} data-cms-box="23">
          {props.box23}
        </Box>
      </Box>

      {/* Row 10: Box 24 (Service Lines - spans full width) */}
      <Box sx={combineSx(formStyles.box, formStyles.box24)} data-cms-box="24">
        {props.box24}
      </Box>

      {/* Row 11: Boxes 25-30 */}
      <Box sx={combineSx(formStyles.box, formStyles.box25)} data-cms-box="25">
        {props.box25}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box26)} data-cms-box="26">
        {props.box26}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box27)} data-cms-box="27">
        {props.box27}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box28)} data-cms-box="28">
        {props.box28}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box29)} data-cms-box="29">
        {props.box29}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box30)} data-cms-box="30">
        {props.box30}
      </Box>

      {/* Row 12: Boxes 31, 32, 33 */}
      <Box sx={combineSx(formStyles.box, formStyles.box31)} data-cms-box="31">
        {props.box31}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box32)} data-cms-box="32">
        {props.box32}
      </Box>
      <Box sx={combineSx(formStyles.box, formStyles.box33)} data-cms-box="33">
        {props.box33}
      </Box>
    </Box>
  );
};